// extracted by mini-css-extract-plugin
module.exports = {"mark":"mark--2sZtr","selected":"selected--23NH3","highlighted":"highlighted--34qAb","relation":"relation--E4JQn","delete":"delete--LC6Rz","row":"row--zlvG1"};
    if(module.hot) {
      // 1637785525863
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  